
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/virtual-sales-rep",
      function () {
        return require("private-next-pages/features/virtual-sales-rep.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/virtual-sales-rep"])
      });
    }
  